import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Ativo', flex: 1.2 },
  { title: 'Tipo' },
  { title: 'Qtd. disponível' },
  { title: 'Qtd. bloqueada' },
  { title: 'Qtd. total' },
  { title: 'Vencimento' },
  { title: 'Valor bruto' },
  { title: '' },
];
